// +----------------------------------------------------------------------
// | Desc:【全局框架集】导入VUE
// +----------------------------------------------------------------------
import Vue from 'vue'
import App from '@/layout/pages/App.vue'

// +----------------------------------------------------------------------
// | Desc:【全局框架集】引入全局配置
// +----------------------------------------------------------------------
import {
    router
} from '@/layout/globalConfig.js'


// +----------------------------------------------------------------------
// | Desc:【项目配置集】配置项目API管理库
// +----------------------------------------------------------------------
import api from '@/config/api'
Vue.prototype.$api = api


// +----------------------------------------------------------------------
// | Desc:【项目配置集】配置项目数据状态库
// +----------------------------------------------------------------------
import state from '@/config/state.js'
Vue.prototype.$state = state

// +----------------------------------------------------------------------
// | Desc:全局注册状态申明(js中使用$S,模板中使用$s())
// +----------------------------------------------------------------------
import $STATE from '@/config/state'
Vue.prototype.$s = function (name, value) {
    return $STATE[name][value];
};


// +----------------------------------------------------------------------
// | Desc:【项目配置集】配置项目CSS工具库
// +----------------------------------------------------------------------
import '@/configOs/css/config.less';


// +----------------------------------------------------------------------
// | Desc:【项目配置集】配置项目JS工具库
// +----------------------------------------------------------------------
import '@/configOs/js/config.js'


// +----------------------------------------------------------------------
// | Desc:【框架集】注册Vue
// +----------------------------------------------------------------------
Vue.config.productionTip = false
new Vue({
    router,
    render: h => h(App),
}).$mount('#app')